import Axios  from 'axios'
import Util from '@/lib/utils.js'
import store from '@/store'
import Qs from 'qs'
import Session_id from './session_id'

let $http = Axios.create({
  timeout: 30000,
  baseURL:'https://m.xiaobaoshuvip.com',
   transformRequest: [function (data) {
    // 对 data 进行任意转换处理
    data = Qs.stringify(data);
    return data;
  }],
});
$http.$axios = Axios;

 // 添加请求拦截器
$http.interceptors.request.use(function (config) {
      // 在发送请求之前做些什么
      // if(!isLogin()){
      //   // goLogin();
      //   return
      // }else{
      // }
      // let sessionId = getSessionId();
      // if(process.env.NODE_ENV == 'development'){  //开发环境
      //   config.url = config.url.replace(/http[s]?:\/\/test.duobao100.com/,'') 
      // }
      // config.headers.common['Session-Id'] = sessionId;
      // config.headers.common['Main-Body'] = 'xiaobaoshu';
      // config.headers.common['source'] = 'xiaobaoshu';
      return config;
    }, function (error) {
      // 对请求错误做些什么
      return Promise.reject(error);
})

// 添加响应拦截器
$http.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    let loginTimes = iCookie.get('login_times',{path:'/'})||0;
    if(loginTimes!=0){
      iCookie.remove('login_times',{path:'/'});
    }
    return response;
  }, function (error) {
    // console.dir(error)
    if(error.response&&error.response.status == 401){
      // iCookie.remove('session_id',{path:'/'})
      // goLogin();
    }
    // if(error.response.data&&error.response.data.info){
    //   Util.toast(error.response.data.info);
    // }
    // 对响应错误做点什么
    return Promise.reject(error);
 });


//路由登录管理
// router.beforeEach((to,from,next)=>{
//   if(to.matched.some(recode => recode.meta.noAuth)){
//     next()
//   }else{
//     if(store.state.user.sessionId){
//       next()
//       return
//     }else{
//       // goLogin();
//       console.log("没登录过");
//     }
//   }
// })



function isLogin(){
  let sessionId = getSessionId();
  // console.log('sessionId1:',sessionId);
  if(!sessionId){
    return false;
  }else{
    return true;
  }
}

function getSessionId(){
  let sessionId = iCookie.get('session_id',{path:'/'}); //生产环境
  if(process.env.NODE_ENV == 'development'){  // 开发环境
    return Session_id;
  }
  return sessionId;
}

function goLogin(){
  if(process.env.NODE_ENV == 'development'){  //开发环境
     return 
  }
  if(!window.location){
    return
  }
  let loginTimes = iCookie.get('login_times',{path:'/'})||0;
  let currentUrl = encodeURIComponent(window.location._href);
  let loginUrl = "/xbs/h5login?url="+currentUrl;
  loginTimes = loginTimes*1 +1;
  if(loginTimes>=8){
    setTimeout(()=>{  //超过8次失败之后三秒钟之后再授权一次
      window.location.href= loginUrl; 
    },3000)
    return
  }
  iCookie.set('login_times',loginTimes,{path:'/',expires: 0.0001});  //10s
  window.location.href= loginUrl; 
}

$http.$fn = {
	isLogin,getSessionId,goLogin,
	getUserInfo(){
		let userInfo = store.state.user.userInfo;
		if(!userInfo){
			return $http.get('/api/v1/users/my').then(response=>{
			let userInfo = response.data.data;
				store.dispatch('setUserInfo',userInfo);
				return userInfo;
			})
		}else{
			return new Promise((resolve,reject)=>{
				resolve(userInfo)
			})
		}
		
  },
        /**
		 * 数据统计
		 * @param  {string} analytic_type 数据类型
		 * @param  {string} analytic_id   数据id
         * @param  {string} user_id   用户id（可选）
		 * @return {void}
		 */
    postClickData({analytic_type, analytic_id,detail,user_id}){
      // console.log(Util.isUndefined(analytic_type), Util.isUndefined(analytic_id))
      if (Util.isUndefined(analytic_type) || Util.isUndefined(analytic_id)) return;
      if(user_id){
        this.postClickDataAjax({ analytic_type, analytic_id, detail, user_id })
      }else{
        this.getUserInfo().then(userInfo=>{
          this.postClickDataAjax({analytic_type, analytic_id, detail, user_id:userInfo.user_id})
        })
      }
    },
    postClickDataAjax({analytic_type, analytic_id,detail,user_id}){
      if (!analytic_type || !analytic_id) return;
      console.log('click',analytic_type,analytic_id)
      var timestamp = (Date.parse(new Date())/1000).toString();
      var thedata = new Object();
      if (user_id) thedata.user_id = user_id;
      let obj = {
          "type":analytic_type,
          "click_time":timestamp,
          "data_id":analytic_id,
      }
      if(detail) obj.detail = detail;
      var strdata = [obj];
      thedata.data = JSON.stringify(strdata);
      $http.post('/api/v1/miniWechat/update_click_data',thedata).then(response => {
      }).catch(function(response){
      });
    }
}
export default $http;


// WEBPACK FOOTER //
// ./src/lib/network.js